function changeImage(element){
  $(element).each(function() {
    const $this = $(this);
    if ($this.data('mobile') && $(window).width() < 768) {
      if ($this[0].nodeName === "IMG") {
        $this.attr('src', $this.data('mobile'));
      }else {
        $this.css({
          'background-image': `url(${$this.data('mobile')})`
        });
      }
    }
  })
}

module.exports = {
  changeImage
};



// WEBPACK FOOTER //
// ../assets/js/change-image.js